

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var targetClassName =
	{
		install:"js-btn-install",
		startup:"js-btn-startup"
	}

	var wrapperButtonClassName = "js-app-btn" ;
	var wrapperQRClassName = "js-app-qr" ;

	// サイトを判別する文字列を入れてください
	var campaign = location.pathname ;

	var SettingURLData =
	{
		install:"https://161118.tlnk.io/serve?action=click&publisher_id=102310&site_id=88610&site_id_ios=88612&sub_campaign="+campaign+"&sub_ad="+campaign ,
		startup_ios:"monsterstrike-app://?reengagement=1&publisher_id=102310&invoke_id=34418&sub_campaign="+campaign+"&sub_ad="+campaign ,
		startup_android:"monsterstrike-app://?reengagement=1&publisher_id=102310&invoke_id=31742&sub_campaign="+campaign+"&sub_ad="+campaign
	}


//------------------------------------------------------------------------------------------------------------------------------


	var AppButton = function( )
	{
		var _this = this , i , temp ;
		var btns ;


		//


		var ua = navigator.userAgent.toLowerCase( ) ;
		var isIOS = /iphone;|ipad;|ipod;/.test(ua) ;
		var isAndrtoid = /android/.test(ua) ;
		var androidVersion = isAndrtoid ? parseFloat( ua.slice(ua.indexOf("android")+8) ) : 0 ;

		var device = 	isIOS ? "ios" :
						isAndrtoid ? "android" : "pc" ;

		// PCだった場合リンクの設定処理を行わない
		//
		if( device == "pc" )
		{
			var hiddenTarget = document.getElementsByClassName( wrapperButtonClassName ) ;
			for( i = 0 ; i < hiddenTarget.length ; i++ )
			{
				hiddenTarget[i].style.display = "none" ;
			}
			var Fit = window.Fit ;
			if( Fit ){
				Fit.fit( );
			}
			return ;
		}else {
			var hiddenTarget = document.getElementsByClassName( wrapperQRClassName ) ;
			for( i = 0 ; i < hiddenTarget.length ; i++ )
			{
				hiddenTarget[i].style.display = "none" ;
			}
		}


		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


		var query = getQuery( ) ;
		if( query.utm_source )	sessionStorage.utm_source = encodeURIComponent( query.utm_source ) ;

		if( sessionStorage.utm_source )
		{
			temp = sessionStorage.utm_source ;
			SettingURLData.startup_ios = SettingURLData.startup_ios + temp ;
			SettingURLData.startup_android = SettingURLData.startup_android + temp ;
			SettingURLData.install = SettingURLData.install + temp ;
		}


		// bypassリテンション広告用の記述

		var REG_bypass = /bypass/g ;
		if( REG_bypass.test( location.search ) )
		{
			temp = location.search.split( "bypass" )[1] ;
			SettingURLData.startup_ios = SettingURLData.startup_ios + temp ;
			SettingURLData.startup_android = SettingURLData.startup_android + temp ;
			SettingURLData.install = SettingURLData.install + temp ;
		}

		//


		// Android5.0系以上のchrome以外のブラウザ（webview製のブラウザ）からストア起動ができない問題の対策
		if( androidVersion >= 5 && /; wv/.test(ua) )
		{
			SettingURLData.install = "https://play.google.com/store/apps/details?id=jp.co.mixi.monsterstrike&hl=ja" ;
		}


		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


		// ストア起動ボタンの実装
		btns = document.getElementsByClassName( targetClassName.install ) ;
		for( i = 0 ; i < btns.length ; i++ )
		{
			btns[i].href = SettingURLData.install ;
		}


		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


		// アプリ起動ボタンの実装
		btns = document.getElementsByClassName( targetClassName.startup ) ;
		for( i = 0 ; i < btns.length ; i++ )
		{
			btns[i].href = isAndrtoid ? SettingURLData.startup_android :
										SettingURLData.startup_ios ;
		}
	}


//------------------------------------------------------------------------------------------------------------------------------


	var getQuery = function( )
	{
		var obj = {} ;
		var value ;
		var i ;

		var query = window.location.search.slice(1).split( "&" ) ;

		for( i in query )
		{
			value = query[ i ].split("=") ;

			if( value.length != 2 )	 value.push( null ) ;

			obj[ value[0] ] = value[1] ;
		}

		return obj ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	// DOMの準備が完了したら実行
	document.readyState === "complete"
		? setTimeout( function(){ new AppButton( ); } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new AppButton( ); } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
